import * as R from "../ramda";
const traverseType = {
  topDown: 'topDown',
  bottomUp: 'bottomUp'
};

const traverseJSONFunction = (data, processItem, config = {}) => {
  const {
    path = [],
    type = traverseType.topDown
  } = config;

  const iterator = (value, key) => {
    const currentPath = [...path, `${key}`];
    const innerResult = traverseJSONFunction(value, processItem, {
      path: currentPath,
      type
    });
    return innerResult;
  };

  return R.ifElse(R.equals(traverseType.topDown), () => {
    const result = processItem(data, path);
    return R.cond([[R.isPlainObject, R.mapObjIndexed(iterator)], [R.isArray, R.mapIndexed(iterator)], [R.T, R.identity] // @ts-ignore
    ])(result);
  }, () => {
    const result = R.cond([[R.isPlainObject, R.mapObjIndexed(iterator)], [R.isArray, R.mapIndexed(iterator)], [R.T, R.identity] // @ts-ignore
    ])(data);
    return processItem(result, path);
  })(type);
};

const traverseJSON = traverseJSONFunction;
traverseJSON.topDown = traverseType.topDown;
traverseJSON.bottomUp = traverseType.bottomUp;
traverseJSON.TOP_DOWN = traverseType.topDown;
traverseJSON.BOTTOM_UP = traverseType.bottomUp;
export default traverseJSON;